import {
    DlpTrackCountPerGroupType,
    DlpTrackCountPerUserType,
    DlpTrackCountType,
    CostsPerAssistantType,
    CostsPerChatModelType,
    CostsPerEmbeddingModelType,
    PerDayType,
    CostsPerGroupType,
    CostsPerUserType,
    CostsPerVoiceModelType,
    CostsPerPromptFunctionType,
} from '../Types';
import requestClient from '../components/Utility/RequestClient';

export const dashboardService = {
    getLicences: async (demo: boolean): Promise<{ data: { used: number; free: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/licences`);
    },

    getTotalCost: async (demo: boolean): Promise<{ data: number }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/totalcosts`);
    },

    getTotalCredit: async (demo: boolean): Promise<{ data: number }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/totalcredit`);
    },

    getTotalCostByDate: async (demo: boolean, from: string, to: string): Promise<{ data: number }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/totalcosts?fromDateTime=${from}&toDateTime=${to}`);
    },

    getAverageCostByDate: async (demo: boolean, from: string, to: string): Promise<{ data: number }> => {
        return requestClient.get(
            `${demo ? '/demo' : ''}/dashboard/totalcostsavg?fromDateTime=${from}&toDateTime=${to}`,
        );
    },

    getCostPerDay: async (demo: boolean, from: string, to: string): Promise<{ data: PerDayType[] }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costsperday?fromDateTime=${from}&toDateTime=${to}`);
    },

    getCostsPerUser: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: CostsPerUserType[] }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costsperuser`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getCostsPerGroup: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: CostsPerGroupType[] }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costspergroup`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getCostsPerAssistant: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: CostsPerAssistantType[]; total: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costsperassistant`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getCostsPerChatModel: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: CostsPerChatModelType[]; total: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costsperchatmodel`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getCostsPerEmbeddingModel: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: CostsPerEmbeddingModelType[]; total: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costsperembeddingmodel`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getCostsPerVoiceModel: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: CostsPerVoiceModelType[]; total: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costspervoicemodel`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getCostsPerPromptFunction: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: CostsPerPromptFunctionType[]; total: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costsperpromptfunction`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getTotalDlpTrackCount: async (demo: boolean, from: string, to: string): Promise<{ data: DlpTrackCountType }> => {
        return requestClient.get(
            `${demo ? '/demo' : ''}/dashboard/totaldlptrackcount?fromDateTime=${from}&toDateTime=${to}`,
        );
    },

    getDlpTrackCountPerUser: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: DlpTrackCountPerUserType[]; total: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/dlptrackcountperuser`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getDlpTrackCountPerGroup: async (demo: boolean, from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: DlpTrackCountPerGroupType[]; total: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/dlptrackcountpergroup`, {
            params: { fromDateTime: from, toDateTime: to, page, itemsPerPage, query },
        });
    },

    getExport: async (demo: boolean, from: string, to: string): Promise<{ data: any }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/export?fromDateTime=${from}&toDateTime=${to}`);
    },
};
